import { Info } from 'react-feather';
import styled from 'styled-components';
import breakpoints from 'utils/breakpoints';
import { AccordionDetails } from '@material-ui/core';

export const StyledInfoIcon = styled(Info)`
  && {
    color: #c2d1d9;
    height: 20px;
    width: 20px;
    margin: 0px 5px;
    min-width: 20px;
    min-height: 20px;
  }
`;

export const StyledAccordionDetails = styled(AccordionDetails)`
  &&& {
    padding: 16px;
    background-color: #f2f2f2;
    border-top: 1px solid #e7e7e7;
    @media (max-width: ${breakpoints.xs}) {
      background-color: #ffffff;
      padding: 8px;
    }
  }
`;
